import LayoutBox from "@/layout/LayoutBox.vue";
import AuthGuard from "./auth-guard";
export const hRoute = [
  {
    path: "/userCenter",
    component: LayoutBox,
    name: "UserCenter",
    redirect: "/userCenter",
    children: [
      {
        path: "/userCenter",
        component: () => import("@/views/hUser/index.vue"),
        name: "hCenter",
        meta: {
          title: "Datalang.Menu_BTM_playerinfo",
          noCache: true,
          affix: true,
          keepAlive: true,
          // hideTGBack: true,
        },
        beforeEnter: AuthGuard,
      },
      {
        path: "/video",
        component: () => import("@/views/video/index.vue"),
        name: "video",
        meta: {
          title: "Datalang.home_video7",
          noCache: true,
          affix: true,
          hiddenTabs: false,
          // hideTGBack: true,
        },
      },
      {
        path: "/videoList",
        component: () => import("@/views/videoList/index.vue"),
        name: "videoList",
        meta: {
          title: "Datalang.home_video7",
          noCache: true,
          affix: true,
          hiddenTabs: false,
          // hideTGBack: true,
        },
      },
      {
        path: "/videoDetail",
        component: () => import("@/views/videoDetail/index.vue"),
        name: "videoDetail",
        meta: {
          title: "Datalang.home_video7",
          noCache: true,
          affix: true,
          hiddenTabs: false,
          // hideTGBack: true,
        },
      },
      {
        path: "/user/hFreeBet",
        component: () => import("@/views/freeBet/index.vue"),
        name: "FreeBet",
        meta: {
          title: "Datalang.app_free_BET",
          noCache: true,
          affix: true,
          hiddenTabs: false,
          // hideTGBack: true,
        },
      },
      {
        path: "/user/hAccountInfo",
        component: () => import("@/views/hUser/hAccountInfo/index.vue"),
        name: "hAccountInfo",
        meta: {
          title: "Datalang.Menu_BTM_playerinfo",
          noCache: true,
          affix: true,
          hiddenTabs: true,
        },
        beforeEnter: AuthGuard,
      },
      {
        path: "/user/hWalletRecord",
        component: () => import("@/views/hUser/hWalletRecord/index.vue"),
        name: "hWalletRecord",
        meta: {
          title: "Datalang.Menu_BTM_tranctionrecord",
          noCache: true,
          affix: true,
          hiddenTabs: true,
        },
        beforeEnter: AuthGuard,
      },
      {
        path: "/user/hGameRecord",
        component: () => import("@/views/hUser/hGameRecord/index.vue"),
        name: "hGameRecord",
        meta: {
          title: "Datalang.Menu_BTM_bettingrecord",
          noCache: true,
          affix: true,
          hiddenTabs: true,
        },
        beforeEnter: AuthGuard,
      },
      {
        path: "/user/hNoticeCenter",
        component: () => import("@/views/hUser/hNoticeCenter/index.vue"),
        name: "hNoticeCenter",
        meta: {
          title: "Datalang.Menu_BTM_messagecenter",
          noCache: true,
          affix: true,
          hiddenTabs: true,
        },
        beforeEnter: AuthGuard,
      },
      {
        path: "/user/hFeedBack",
        component: () => import("@/views/hUser/hFeedBack/index.vue"),
        name: "hFeedBack",
        meta: {
          title: "Datalang.Newscenter_BTM_feedback",
          noCache: true,
          affix: true,
          hiddenTabs: true,
        },
        // beforeEnter: AuthGuard,
      },
      {
        path: "/user/hVip",
        component: () => import("@/views/hUser/hVip/index.vue"),
        name: "hVip",
        meta: {
          title: "Datalang.newly_VIP_Club",
          noCache: true,
          affix: true,
          hiddenTabs: true,
        },
        beforeEnter: AuthGuard,
      },
      {
        path: "/user/hReward",
        component: () => import("@/views/reward/index.vue"),
        name: "hReward",
        meta: {
          title: "Datalang.newly_help_money",
          noCache: true,
          affix: true,
          keepAlive: true,
        },
        beforeEnter: AuthGuard,
      },
      {
        path: "/user/hWallet",
        component: () => import("@/views/hUser/hWallet/index.vue"),
        name: "hWallet",
        meta: {
          title: "Datalang.Wallet_BTM_walletdetails",
          noCache: true,
          affix: true,
          hiddenTabs: true,
        },
        beforeEnter: AuthGuard,
      },
      {
        path: "/user/hDistribution",
        component: () => import("@/views/hUser/hDistribution/index.vue"),
        name: "hDistribution",
        meta: {
          title: "Datalang.Threelevelagent_3",
          noCache: true,
          affix: true,
          keepAlive: false, // 1.19.6 1200以上皮肤不要缓存
        },
        beforeEnter: AuthGuard,
      },
      {
        path: "/user/hTask",
        component: () => import("@/views/hUser/hTask/index.vue"),
        name: "hTask",
        meta: {
          title: "Datalang.Invite_TITLE_task",
          noCache: true,
          affix: true,
          keepAlive: false,
        },
        // beforeEnter: AuthGuard,
      },
      {
        path: "/user/hCustomerService",
        component: () => import("@/views/hUser/hCustomerService/index.vue"),
        name: "hCustomerService",
        meta: {
          title: "Datalang.LowH5_BTM_customersupport",
          noCache: true,
          affix: true,
          hiddenTabs: true,
        },
      },
      {
        // beforeEnter: AuthGuard,
        path: "/user/hLanguage",
        component: () => import("@/views/hUser/hLanguage/index.vue"),
        name: "hLanguage",
        meta: {
          title: "Datalang.Personal_TITLE_changelanguage",
          noCache: true,
          affix: true,
          hiddenTabs: true,
        },
      },
      {
        path: "/user/hPromote",
        name: "hPromote",
        component: () =>
          import(/* webpackChunkName: "DownloadApp" */ "@/views/Promotion.vue"),
        meta: {
          title: "Datalang.HomePage_BTM_downloadapp",
          noCache: true,
          affix: true,
          hiddenTabs: true,
        },
      },
      {
        path: "/hEvents",
        component: () => import("@/views/events/index.vue"),
        name: "events",
        meta: {
          title: "",
          noCache: true,
          affix: true,
          // hideTGBack: true,
        },
        // beforeEnter: AuthGuard,
      },
      {
        path: "/hactivityDetail/:id?",
        component: () => import("@/views/activityDetail.vue"),
        name: "hactivityDetail",
        meta: {
          title: "Datalang.Home_Event_Details",
          noCache: true,
          affix: true,
          hiddenTabs: true,
        },
        // beforeEnter: AuthGuard,
      },
      // 文档
      {
        path: "/hpolicy/:type",
        name: "policy",
        component: () =>
          import(/* webpackChunkName: "Home" */ "@/views/policy/index.vue"),
        meta: {
          title: "Datalang.HomePage_TITLE_aboutus",
          noCache: true,
          affix: true,
          hiddenTabs: true,
          // hideTGBack: true,
        },
      },
      {
        path: "/user/hGivingGift",
        component: () => import("@/views/user/givingGift"),
        name: "hGivingGift",
        meta: {
          title: "Datalang.home_Gift",
          noCache: true,
          affix: true,
          hiddenTabs: true,
        },
        beforeEnter: AuthGuard,
      },
      // {
      //   path: "/hHash",
      //   name: "hHash",
      //   component: () => import(/* webpackChunkName: "Home" */ "@/views/policy/hIndex.vue"),
      //   meta: {
      //     title: "Datalang.HomePage_BTM_hash",
      //     noCache: true,
      //     affix: true,
      //     hiddenTabs: true,
      //   },
      // },
    ],
    // beforeEnter: AuthGuard,
  },
  {
    // 移动端玩游戏
    // path: "/payGame/:gid/:url",
    path: "/payGame/:gid",
    component: () => import("@/components/payGame/payGame.vue"),
    name: "payGame",
    meta: {
      title: "route.payGame",
      noCache: true,
      affix: true,
      hiddenTabs: true,
    },
    beforeEnter: AuthGuard,
  },
  {
    path: "/hCooperation",
    component: () => import("@/views/cooperation/hIndex.vue"),
    name: "hCooperation",
    meta: {
      title: "Datalang.promotion_TITLE_BusinessCoo",
      noCache: true,
      affix: true,
      hiddenTabs: true,
      // hideTGBack: true,
    },
    // beforeEnter: AuthGuard,
  },
  // {
  //   path: "/video",
  //   component: () => import("@/views/video/index.vue"),
  //   name: "video",
  //   meta: {
  //     title: "",
  //     noCache: true,
  //     affix: true,
  //     hiddenTabs: false,
  //     // hideTGBack: true,
  //   },
  //   beforeEnter: AuthGuard,
  // },
];
